import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=b866742a&scoped=true"
import script from "./Conference.vue?vue&type=script&lang=js"
export * from "./Conference.vue?vue&type=script&lang=js"
import style0 from "./Conference.vue?vue&type=style&index=0&id=b866742a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b866742a",
  null
  
)

export default component.exports